import MultiSelectSearchDropdown from './MultiSelectSearchDropdown'

export default MultiSelectSearchDropdown



// WEBPACK FOOTER //
// ./src/legacy/components/MultiSelectSearchDropdown/index.js